"use client"

import HomeClient from "@/components/public/home/home-client";

export default function LandingPage() {
    return (
        <main className="flex-1 w-full">
            <HomeClient />
        </main>
    );
}
